// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AssetClassFromJSON, AssetClassToJSON, FundInvestmentSubscriptionFromJSON, FundInvestmentSubscriptionToJSON, } from './';
export function FundFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'assetClass': !exists(json, 'assetClass') ? undefined : AssetClassFromJSON(json['assetClass']),
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'manager': !exists(json, 'manager') ? undefined : json['manager'],
        'strategy': !exists(json, 'strategy') ? undefined : json['strategy'],
        'geography': !exists(json, 'geography') ? undefined : json['geography'],
        'nav': !exists(json, 'nav') ? undefined : json['nav'],
        'commitment': !exists(json, 'commitment') ? undefined : json['commitment'],
        'contributions': !exists(json, 'contributions') ? undefined : json['contributions'],
        'distributions': !exists(json, 'distributions') ? undefined : json['distributions'],
        'remainingCommitment': !exists(json, 'remainingCommitment') ? undefined : json['remainingCommitment'],
        'vintageYear': !exists(json, 'vintageYear') ? undefined : json['vintageYear'],
        'referenceDate': !exists(json, 'referenceDate') ? undefined : new Date(json['referenceDate']),
        'commitmentDate': !exists(json, 'commitmentDate') ? undefined : new Date(json['commitmentDate']),
        'subscriptions': !exists(json, 'subscriptions') ? undefined : json['subscriptions'].map(FundInvestmentSubscriptionFromJSON),
        'latestCapitalAccountReportedDate': !exists(json, 'latestCapitalAccountReportedDate') ? undefined : new Date(json['latestCapitalAccountReportedDate']),
    };
}
export function FundToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'assetClass': AssetClassToJSON(value.assetClass),
        'currency': value.currency,
        'manager': value.manager,
        'strategy': value.strategy,
        'geography': value.geography,
        'nav': value.nav,
        'commitment': value.commitment,
        'contributions': value.contributions,
        'distributions': value.distributions,
        'remainingCommitment': value.remainingCommitment,
        'vintageYear': value.vintageYear,
        'referenceDate': value.referenceDate === undefined ? undefined : value.referenceDate.toISOString(),
        'commitmentDate': value.commitmentDate === undefined ? undefined : value.commitmentDate.toISOString(),
        'subscriptions': value.subscriptions === undefined ? undefined : value.subscriptions.map(FundInvestmentSubscriptionToJSON),
        'latestCapitalAccountReportedDate': value.latestCapitalAccountReportedDate === undefined ? undefined : value.latestCapitalAccountReportedDate.toISOString(),
    };
}
